import { useQuery } from '@apollo/client';
import { useEffect } from 'react';
import { GET_COMPANY_THEME_SETTINGS } from './apollo-client/graphql/company/company.query';
import Chatbot from './components/chatbot/chatbot';
import { changeHTMLAttribute } from './utils/change-html-attribute';

function App() {

  // GET BUSINESS ID FROM URL
  const queryString = window.location.search;
  const queryParams = new URLSearchParams(queryString);
  const businessId = queryParams.get('businessid');

  // GET & APPLY THEME OF COMPANY CONFIG
  const { data } = useQuery(GET_COMPANY_THEME_SETTINGS, { variables: { companyId: businessId }, fetchPolicy: "cache-and-network", skip: !businessId });
  useEffect(() => {
    if (data?.getCompanyThemeSettings) {
      localStorage.setItem("themeSettings", JSON.stringify(data?.getCompanyThemeSettings), { sameSite: 'None', secure: true });
      // changeHTMLAttribute("theme", data?.getCompanyThemeSettings?.theme);
      changeHTMLAttribute("radius", data?.getCompanyThemeSettings?.radius);
      changeHTMLAttribute("style", data?.getCompanyThemeSettings?.style);
      changeHTMLAttribute("skin", data?.getCompanyThemeSettings?.skin);
      changeHTMLAttribute("dir", data?.getCompanyThemeSettings?.dir);
    }
  }, [data?.getCompanyThemeSettings])

  return (
    <Chatbot />
  );
}

export default App;
